/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Sendotp1Inputs */

const he_auth_signup_sendotp1 = /** @type {(inputs: Auth_Signup_Sendotp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלח קוד הרשמה`)
};

const en_auth_signup_sendotp1 = /** @type {(inputs: Auth_Signup_Sendotp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send sign-up code`)
};

/**
* | output |
* | --- |
* | "Send sign-up code" |
*
* @param {Auth_Signup_Sendotp1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_signup_sendotp1 = /** @type {((inputs?: Auth_Signup_Sendotp1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Sendotp1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_sendotp1(inputs)
	return en_auth_signup_sendotp1(inputs)
});
export { auth_signup_sendotp1 as "auth_signup_sendOtp" }